// Shared constants for file type validation
// Must match FaceSwitchingTask::ALLOWED_IMAGE_CONTENT_TYPES in Ruby

export const ALLOWED_IMAGE_TYPES = [
  'image/jpeg',
  'image/jpg', 
  'image/png',
  'image/webp'
];

export const isAllowedImageType = (mimeType) => {
  return ALLOWED_IMAGE_TYPES.includes(mimeType);
};